module.exports = __webpack_public_path__ + "img/crusher.d81035ca.png";